import React from 'react'

import CounterChart from '../../_shared/charts/counter/CounterChart'
import PlacesCounterLoader, { useAllPlacesCounter, usePlacesCounter } from './_load/PlacesCounterLoader'
import WidgetWrapper from '../../WidgetWrapper'

const Widget = props => {
  const { widget } = props
  const value = usePlacesCounter()
  const all = useAllPlacesCounter()

  return <CounterChart value={value} all={all} name={widget.name} {...widget.data} />
}

const Wrapper = props => {
  const { widget } = props

  return (
    <WidgetWrapper {...props}>
      <PlacesCounterLoader widget={widget}>
        <Widget widget={widget} />
      </PlacesCounterLoader>
    </WidgetWrapper>
  )
}

export default Wrapper
